import React from 'react';
import useAppStore from '../../store/useAppStore.js';
import './TopNav.css';

export default function TopNav({ onRefresh, title = 'Multi-Strategy Signals', subtitle = 'React + Lightweight Charts' }) {
  const { lastUpdated, cacheVersion } = useAppStore();

  const formatTime = (timestamp) => {
    if (!timestamp) return 'Never';
    const date = new Date(timestamp);
    return date.toLocaleTimeString();
  };

  return (
    <div className="top-nav">
      <div className="top-nav-left">
        <h1 className="top-nav-title">{title}</h1>
        <span className="top-nav-subtitle">{subtitle}</span>
      </div>

      <div className="top-nav-right">
        <div className="top-nav-status">
          <span className="status-label">Last Updated:</span>
          <span className="status-value">{formatTime(lastUpdated)}</span>
        </div>

        <button onClick={onRefresh} className="refresh-btn">
          ↻ Refresh
        </button>
      </div>
    </div>
  );
}
